import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { MuralIcon, MuralIconBorderless, MuralSearchResultIcon } from './icon';

export const muralConfig: ThirdPartyConfig = {
	displayName: 'Mural',
	id: 'mural',
	resourceType: ProductResourceTypes3P.Mural,
	icon: get3PLogo(MuralIcon, 'Mural', 'medium'),
	iconBorderless: get3PLogo(MuralIconBorderless, 'Mural', 'small'),
	searchResultIcon: get3PLogo(MuralSearchResultIcon, 'Mural', 'large'),
	integrationAri: 'ari:cloud:platform::integration/mural',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Design],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
